module.exports = __webpack_public_path__ + "static/logo-4626d52d516c9f7ccacc4ff1943ba71b.png";